import { fleet } from 'services'
import * as applicationActions from 'actions/application'

export const SET_SOURCE_VEHICLE = 'SET_SOURCE_VEHICLE'
export const setSourceVehicle = ({ fleetUri, serialNumber }) => ({
  type: SET_SOURCE_VEHICLE,
  serialNumber,
  fleetUri,
})

export const GET_FLEET_INFORMATION = 'GET_FLEET_INFORMATION'
export const getFleetTrucksStub = ({ id }) =>
  applicationActions.apiActionStub({
    successActionType: GET_FLEET_INFORMATION,
    asyncFn: fleet.getFleet,
    id,
  })

export const getFleetTrucks = ({ serialNumber }) =>
  applicationActions.apiAction({
    successActionType: GET_FLEET_INFORMATION,
    asyncFn: fleet.getFleet,
    args: { serialNumber },
    id: serialNumber,
  })

export const HANDLE_FLEET_VEHICLE_SELECT = 'HANDLE_FLEET_VEHICLE_SELECT'
export const handleSelectFleetVehicle = ({ serialNumber, fleetUri }) => ({
  type: HANDLE_FLEET_VEHICLE_SELECT,
  payload: { serialNumber, fleetUri },
})

export const CLEAR_ALL_SELECTED_TRUCKS = 'CLEAR_ALL_SELECTED_TRUCKS'
export const clearAllSelectedTrucks = ({ fleetUri }) => ({
  type: CLEAR_ALL_SELECTED_TRUCKS,
  payload: { fleetUri },
})

export const UPDATE_FLEET = 'UPDATE_FLEET'
export const updateFleet = ({
  serialNumber,
  notes,
  leadSerialNumber,
  fleetUri,
  fleetName,
  setPto,
  setFeatures,
  ptoExclusions,
  featuresExclusions,
}) => ({
  type: UPDATE_FLEET,
  serialNumber,
  notes,
  leadSerialNumber,
  fleetUri,
  fleetName,
  ptoExclusions,
  featuresExclusions,
  setPto,
  setFeatures,
})
